import type { HybridspaceAgendaPanelProps } from './components/HybridspaceAgendaPanel';
import type * as lazyIndex from './lazyIndex';
import './observableTodayChangedOrchestrator';
import { createLazyComponent, type LazyComponent, LazyImport, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName: "HybridspaceAgendaPanel" */ './lazyIndex'),
    { name: 'HybridspaceAgendaPanel' }
);

export const HybridspaceAgendaPanel: LazyComponent<HybridspaceAgendaPanelProps, unknown, void> =
    createLazyComponent(lazyModule, m => m.HybridspaceAgendaPanel);

export const lazyHybridspaceAgendaPanelModule: LazyImport<
    typeof lazyIndex,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m);
